<div class="wrap w-full text-center leading-snug">
    <ng-container *ngFor="let item of displayedTextList; let i = index; trackBy: trackByFn" >
      <div *ngIf="item.animate; else noAnimate" [ngClass]="item.cssClass" [@changeText] [ngStyle]="{'--bg-color': item.backgroundColor}" class="frosty px-2">{{item.text}}
        <span class="reveal"></span>
      </div>
      <ng-template #noAnimate>
        <div [ngClass]="item.cssClass" [ngStyle]="{'--bg-color': item.backgroundColor}" class="frosty px-2">{{item.text}}</div>
      </ng-template>
    </ng-container>
  </div>